import React, { useState } from 'react';
import Icons from './Icons';
import LinkInfo from './LinkInfo';

const SideBar: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="custom-sidebar group bg-[#0A3690]">
      <div className="w-[100px] group-hover:w-[100px] flex flex-col items-center gap-y-4">
        <Icons
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
        />
      </div>
      <div className="w-0 opacity-0 overflow-hidden transition-all duration-300 ease-in-out group-hover:w-full group-hover:opacity-100 flex flex-col gap-y-4">
        <LinkInfo
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
        />
      </div>
    </div>
  );
};

export default SideBar;
